module.exports = __webpack_public_path__ + "img/235.fc25e485.png";